import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { useDroppable } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import DragItem from "./DragItem";
import { Lesson } from "./types";
import AddLessionModal from "../../../../modal/add-lession";
import AddLessionDrawer from "../../../../drawer/add-lesstion";
import AddLearningMaterialsReferences from "../../../../drawer/add-learning-materials-references/AddLearningMaterialsReferences";
import AddLearningMaterials from "../../../../drawer/add-learning-materials/AddLearningMaterials";
import { globalStore } from "../../../../../stores/stores";

export function LessonContainer({ lesson, dataConfig }: { lesson: Lesson, dataConfig: Lesson }) {
  const { t } = useTranslation();
  const { reload, setReload } = globalStore()
  const { setNodeRef, isOver } = useDroppable({ id: `lesson-${lesson.id}` });
  const [isOpenAddLessionDrawer, setIsOpenAddLessionDrawer] =
    useState<boolean>(false);
  const [isOpenAddLessonModal, setIsOpenAddLessonModal] =
    useState<boolean>(false);
  const [isAddLearningMaterialsReferences, setIsAddLearningMaterialsReferences] =
    useState<boolean>(false);
  const [isAddLearningMaterials, setIsAddLearningMaterials] =
    useState<boolean>(false);
  const [multimediaType, setMultimediaType] = useState<string>("");

  const confirmAddLesson = () => {
    setIsOpenAddLessonModal(false);
    setIsOpenAddLessionDrawer(true);
  };
  const handleChangeMenuType = (type: any) => {
    if (type.includes("reference")) {
      setIsAddLearningMaterialsReferences(type !== "");

    } else {
      setIsAddLearningMaterials(type !== "");
    }
    setMultimediaType(type)
  }

  return (
    <div ref={setNodeRef} style={{ padding: 8, background: isOver ? "#fffbe6" : "#fff" }}>
      <DragItem item={lesson} type="LESSON" dataConfig={dataConfig} />
      <SortableContext items={lesson.children.map((r) => r.id)} strategy={verticalListSortingStrategy}>
        {lesson.children.map((resource) => (
          <DragItem key={resource.id} item={resource} type="RESOURCE" dataConfig={dataConfig} />
        ))}
      </SortableContext>
      <div
        className="add-lesson-btn"
        onClick={() => setIsOpenAddLessonModal(true)}
      >
        <div>+</div>
        {t("Thêm học liệu", "Thêm học liệu")}
      </div>

      {isOpenAddLessonModal && <AddLessionModal
        open={isOpenAddLessonModal}
        title={t("Chọn học liệu", "Chọn học liệu")}
        closeIcon={true}
        okText={t("Xác nhận", "Xác nhận")}
        cancelText={t("Huỷ", "Huỷ")}
        icon={null}
        confirm={confirmAddLesson}
        multimediaType={handleChangeMenuType}
        closeModal={() => setIsOpenAddLessonModal(false)}

      />}

      {isOpenAddLessionDrawer &&
        <AddLessionDrawer
          isScheduleByTeacher={dataConfig.isScheduleByTeacher}
          open={isOpenAddLessionDrawer}
          onClose={() => setIsOpenAddLessionDrawer(false)}
          id={lesson.id}
          sequenceId={Number(lesson.id)}
          parentName={lesson.name}
        />
      }

      {isAddLearningMaterialsReferences &&
        <AddLearningMaterialsReferences
          id={lesson.id}
          sequenceId={lesson.id}
          title="Basic Drawer"
          setIsOpenDrawer={setIsAddLearningMaterialsReferences}
          open={isAddLearningMaterialsReferences}
          handleDetail={() => setReload(!reload)}
          itemDetail={lesson}
          isEdit={false}
          multimediaType={multimediaType}
        />}

      {isAddLearningMaterials &&
        <AddLearningMaterials
          id={lesson.id}
          sequenceId={lesson.id}
          title="Basic Drawer"
          setIsOpenDrawer={setIsAddLearningMaterials}
          open={isAddLearningMaterials}
          handleDetail={() => setReload(!reload)}
          itemDetail={lesson}
          isEdit={false}
          multimediaType={multimediaType}
        />}
    </div>
  );
}
